module.exports = __webpack_public_path__ + "static/Logo-939dc3db8554d39b4d63e947257819ab.svg";